import { Component, OnInit } from '@angular/core';
import { GungSettingsBaseViewComponent } from '../../gung-settings-base-view/gung-settings-base-view.component';
import { ApiConfiguration, GungSettingsApiService } from '../../../services/gung-settings-api.service';
import { first } from 'rxjs';
import { GungConfiguration } from '../../../services/configurations.service';
import { GungNotificationService } from 'gung-common';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'lib-gung-settings-api',
  templateUrl: './gung-settings-api.component.html',
  styleUrl: './gung-settings-api.component.scss'
})
export class GungSettingsApiComponent extends GungSettingsBaseViewComponent implements OnInit {
  apiConfigurations: GungConfiguration;
  pushTransformers: { [key: string]: string }[] = [];

  constructor(
    protected apiConfigurationService: GungSettingsApiService,
    protected notificationService: GungNotificationService,
    protected translationService: TranslateService
  ) {
    super();
  }

  ngOnInit(): void {
    this.apiConfigurationService
      .getApiConfigurations()
      .pipe(first())
      .subscribe(configs => {
        console.log('configs', configs);
        for (const pushTransform in configs?.pushTransformers) {
          if (Object.prototype.hasOwnProperty.call(configs.pushTransformers, pushTransform)) {
            const element = configs.pushTransformers[pushTransform];
            this.pushTransformers.push({
              entity: pushTransform,
              value: element
            });
          }
        }
        this.apiConfigurations = configs;
      });
  }

  addEntity() {
    this.apiConfigurations.additionalEntities.push({
      entity: '',
      relatedMainEntity: ''
    });
  }

  addPushTransformers() {
    this.pushTransformers.push({
      entity: '',
      value: ''
    });
  }

  removeAdditionalEntities(j) {
    this.apiConfigurations.additionalEntities.splice(j, 1);
  }

  removePushTransformers(i) {
    this.pushTransformers.splice(i, 1);
  }

  save() {
    this.apiConfigurations.pushTransformers = {};
    for (const pushTransform of this.pushTransformers) {
      if (pushTransform.entity) {
        this.apiConfigurations.pushTransformers[pushTransform.entity] = pushTransform.value;
      }
    }
    this.apiConfigurationService
      .saveApiConfigurations(this.apiConfigurations)
      .pipe(first())
      .subscribe(config => {
        this.notificationService.notify('', this.translationService.instant('API_SETTINGS_SAVED'), 'success');
      });
  }
}
